import { type Arguments as SWRArguments, type Key as SWRKey } from 'swr'

type NullArguments = null | undefined | false

export type Key<Params, Arguments extends SWRArguments> = Arguments | NullArguments | ((params?: Params) => Arguments | NullArguments)

export const serializeKey = <Params, Arguments extends SWRArguments>(
  key: Key<Params, Arguments>,
  params?: Params,
): SWRKey => (typeof key === 'function' ? key(params) : key)
